import { render, staticRenderFns } from "./VisitWindowBox.vue?vue&type=template&id=f6df6f8a&scoped=true&"
import script from "./VisitWindowBox.vue?vue&type=script&lang=js&"
export * from "./VisitWindowBox.vue?vue&type=script&lang=js&"
import style0 from "./VisitWindowBox.vue?vue&type=style&index=0&id=f6df6f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6df6f8a",
  null
  
)

export default component.exports